import './App.css';
import Desktop from './components/os/Desktop';

function App() {
    return (
        <div className="App">
            <Desktop />
        </div>
    );
}

export default App;
